function wkUpdateShippingBar(itemCount) {
  const THRESHOLD = 2;
  const bar = document.querySelector('#wk-shipping-bar');
  if (!bar) return;
  const message = bar.querySelector('.wk-bar-message');
  const fill = bar.querySelector('.wk-bar-fill');
  const progress = Math.min(itemCount / THRESHOLD, 1) * 100;
  fill.style.width = progress + '%';
  fill.classList.toggle('is-complete', itemCount >= THRESHOLD);

  if (itemCount === 0) {
    message.textContent = '🎲 Ab 2 Artikeln ist der Versand kostenlos!';
  } else if (itemCount < THRESHOLD) {
    message.innerHTML = `🎯 Noch ${THRESHOLD - itemCount} Artikel bis zum <strong>kostenlosen Versand</strong>`;
  } else {
    message.textContent = '✓ Kostenloser Versand freigeschaltet!';
  }
}

async function wkRefreshFromCartApi() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  wkUpdateShippingBar(cart.item_count);
}

document.addEventListener('cart:update', wkRefreshFromCartApi);
document.addEventListener('DOMContentLoaded', wkRefreshFromCartApi);